import Swiper from "swiper"
import React, { Fragment, useEffect, useState } from "react"
import * as languages from "../../../languages"
import "./index.scss"
import { ImageHeader } from "../imageHeader"
import filter from "../../images/filter-icon.png"
import { AppButton } from "../button"
import { AppLink } from "../appLink"
import { connect } from "react-redux"
import useMediaQuery from "@material-ui/core/useMediaQuery"

export const CategorySlider = connect(state => state.app.productFilters)(({ category, pageContext, switchLayout, ...props }) => {

  // console.log('slider selected filters', props.selectedFilters);

  const isDesktop = useMediaQuery("(min-width:600px)")
  const [loadMore, setLoadMore] = useState(4)
  const [product, setProduct] = useState('');

  useEffect(() => {

    let found
    let indexOf
    const hashParts = props.location.hash.split("#")

    let sliderHash
    if (hashParts.length > 2) {
      sliderHash = hashParts.slice(-1)[0]
    }

    if (category && validateCategory() && !switchLayout) {
      if (sliderHash !== '') {
        found = category && category.products && category.products.find(({ product }) => product?._meta?.uid === sliderHash)
        indexOf = category.products.indexOf(found)
        // console.log("found", found);
        // console.log("indexOf", indexOf);
        setProduct(sliderHash);
      } else {
        setProduct('')
      }

      const bgSwiper = new Swiper(`.back-slider.swiper-container.${category?._meta.uid + "1"}`, {
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false
        },
        slidesPerView: 1,
        initialSlide: indexOf !== -1 ? indexOf : 0
      })

      const frontSwiper = new Swiper(`.front-slider.swiper-container.${category?._meta.uid + "2"}`, {
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false
        },
        slidesPerView: 1.6,
        initialSlide: indexOf !== -1 ? indexOf : 0,
        centeredSlides: true,
        spaceBetween: 10
      })
      frontSwiper.controller.control = bgSwiper

      const bgSwiperDesktop = new Swiper(`.back-slider.swiper-container.${category?._meta.uid + "3"}`, {
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false
        },
        slidesPerView: 1,
        initialSlide: indexOf
      })

      const detailsSwiper = new Swiper(`.details-slider.swiper-container.${category?._meta.uid + "5"}`, {
        touchRatio: 0,
        slidesPerView: 1
      })

      const frontSwiperDesktop = new Swiper(`.front-slider.swiper-container.${category?._meta.uid + "4"}`, {
        navigation: {
          nextEl: ".swiper-button-next" + category?._meta.uid,
          prevEl: ".swiper-button-prev" + category?._meta.uid
        },
        controller: {
          control: [
            detailsSwiper,
            bgSwiperDesktop
          ],
          by: "container"
        },
        slidesPerView: 1.8,
        centeredSlides: true,
        spaceBetween: 10,
        touchRatio: 0,
        initialSlide: indexOf

      })


      const desktopSwiperV2 = new Swiper(`.desktop-slider.swiper-container.${category?._meta.uid + "v2"}`, {
        navigation: {
          nextEl: ".swiper-button-next" + category?._meta.uid,
          prevEl: ".swiper-button-prev" + category?._meta.uid
        },
        slidesPerView: 3,
        spaceBetween: 10,
        touchRatio: 0,
        initialSlide: indexOf && indexOf !== -1 ? indexOf : 1,
        centeredSlides: true
      })

      // frontSwiperDesktop.controller.control = [bgSwiperDesktop, detailsSwiper];
    }

  }, [category, switchLayout, props.location.hash])

  const buttonName = (products) => {
    if (loadMore === 4 && products.length > 4) {
      return <span>more</span>
    } else if (loadMore > 4 && products.length > 4) {
      return <span>less</span>
    }
  }

  const getLang = () => {
    if (pageContext.lang === languages.defaultLang) {
      return ""
    } else {
      return `/${pageContext.lang}`
    }
  }

  /*  const filterByCategory = ({product}) => {
      // console.log(product);
      return true
    }*/

  const validateCategory = () => {
    // console.log(category)
    return !!(category && category.products && category.products.filter(pc => pc.product).length)
  }

  return (
    <Fragment>
      {validateCategory() &&
      <div className="main-wrapper">
        {!switchLayout &&
        (
          <div className="d-block d-sm-none category-slider" id={`_${category?._meta?.uid}#${product}`}>
            {/*<div className="d-block d-sm-none category-slider" >*/}
            <div className={"back-slider swiper-container " + `${category?._meta.uid + "1"}`}>
              <div className="swiper-wrapper">
                {category.products.map(({ product }, index) =>
                  product !== null &&
                  <div key={index.toString()} className="swiper-slide">
                    <ImageHeader imgSrc={product?.background_image?.url} resize/>
                  </div>
                )}
              </div>
              <div className="swiper-scrollbar"/>
            </div>
            <div className={"front-slider swiper-container " + `${category?._meta.uid + "2"}`}>
              <div className="swiper-wrapper">
                {category.products.map(({ product }, index) =>
                  product !== null &&
                  <div key={index.toString()} className="swiper-slide">
                    <div className="mobile-slide-container">
                      <AppLink to={`/${category?._meta.uid}/${product?._meta.uid}`} pageContext={pageContext}>
                        {product && !product.no_aspect_ratio_image && <img className="img-fluid" src={product?.product_image?.url}/>}
                        <img className="img-fluid" src={product?.no_aspect_ratio_image?.url}/>
                        <div className="product-description-container">
                          <h2 className="text-uppercase text-center">{product?.name}</h2>
                        </div>
                      </AppLink>
                    </div>
                  </div>
                )}
              </div>
              <div className="swiper-scrollbar"/>
            </div>
            <h2 className="slider-category-name text-uppercase text-center">{category?.name}</h2>
          </div>
        )}
        {
          switchLayout && (
            <div className="d-block d-sm-none category-grid" id={`_${category?._meta?.uid}`}>
              <h2 className="slider-category-name text-uppercase text-center m-2">{category?.name}</h2>
              {/*<div className="d-block d-sm-none category-slider" >*/}
              <div className={"d-flex row row-container " + `${category?._meta.uid + "2"}`}>
                {category.products.slice(0, loadMore).map(({ product }, index) =>
                  product !== null &&
                  <div key={index.toString()} className="d-inline col-6 text-center padding">
                    <div className="image-container">
                      <AppLink to={`/${category?._meta.uid}/${product?._meta.uid}`} pageContext={pageContext}>
                        {product && !product.no_aspect_ratio_image && <img className="image" src={product?.product_image?.url}/>}
                        <img className="image" src={product?.no_aspect_ratio_image?.url}/>
                      </AppLink>
                    </div>
                    <div className="product-description-container">
                      <span className="text-uppercase text-center product-title">{product?.name}</span>
                    </div>
                  </div>
                )}
              </div>
              <div className="row button-container">
                {
                  category.products.length > 4 &&
                  <div className="show-button">
                    <AppButton type="button" onClick={() => {
                      if (loadMore === 4) {
                        setLoadMore(category.products.length)
                      } else {
                        setLoadMore(4)
                      }
                    }}>
                      {buttonName(category.products)}
                    </AppButton>
                  </div>
                }
                <div className="filter-button">
                  <AppButton>
                    <img src={filter} alt="" height="20px"/>
                  </AppButton>
                </div>
              </div>
            </div>
          )}


        {/*<div className="d-none category-slider" id={category.name.toLowerCase()}>*/}
        {/*  <div className="homepage-desktop">*/}
        {/*    <section className="container-fluid p-0">*/}
        {/*      <div className="row m-0">*/}
        {/*        <div className="page-container d-flex">*/}
        {/*          <div className="desktop-left-section">*/}
        {/*            <div className={"back-slider swiper-container " + `${category?._meta.uid + "3"}`}>*/}
        {/*              <div className="swiper-wrapper">*/}
        {/*                {category.products.map(({ product }, index) =>*/}
        {/*                  <div key={index.toString()} className="swiper-slide">*/}
        {/*                    <div className="desktop-category-slider-background" style={{ backgroundImage: `url('${product?.background_image?.url}')` }}/>*/}
        {/*                  </div>*/}
        {/*                )}*/}
        {/*              </div>*/}
        {/*              <div className="swiper-scrollbar"/>*/}
        {/*            </div>*/}
        {/*            <div className={"front-slider swiper-container " + `${category?._meta.uid + "4"}`}>*/}
        {/*              <div className="swiper-wrapper">*/}
        {/*                {category.products.map(({ product }, index) =>*/}
        {/*                  <div key={index.toString()} className="swiper-slide">*/}
        {/*                    {product && !product.no_aspect_ratio_image && <img className="img-fluid" src={product?.product_image?.url}/>}*/}
        {/*                    <img className="img-fluid" src={product?.no_aspect_ratio_image?.url}/>*/}
        {/*                  </div>*/}
        {/*                )}*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*            <div className={"swiper-button-prev" + " swiper-button-prev" + category?._meta.uid}/>*/}
        {/*            <div className={"swiper-button-next" + " swiper-button-next" + category?._meta.uid}/>*/}
        {/*            /!*<div className="desktop-section-delimiter" style={{ backgroundImage: `url('${desktopDelimiter}')` }}/>*!/*/}
        {/*          </div>*/}
        {/*          <div className="desktop-right-section d-flex flex-column align-items-center justify-content-center"/>*/}
        {/*          <div className="container position-absolute desktop-right-container p-0">*/}
        {/*            <div className="row m-0 justify-content-end">*/}
        {/*              <div className="col-6 pl-5 pr-0 text-center">*/}
        {/*                <img className="img-fluid my-4" src={logo} width="75"/>*/}
        {/*                <h2 className="slider-category-name text-uppercase text-center">{category?.name}</h2>*/}
        {/*                <div className={"details-slider swiper-container " + `${category?._meta.uid + "5"}`}>*/}
        {/*                  <div className="swiper-wrapper">*/}
        {/*                    {category.products.map(({ product }, index) =>*/}
        {/*                      <div key={index.toString()} className="swiper-slide">*/}
        {/*                        <AppLink to={`${getLang()}/${category?._meta.uid}/${product?._meta.uid}`}>*/}
        {/*                          <div className="slider-product-name text-uppercase text-center">{product?.name}</div>*/}
        {/*                          <div*/}
        {/*                            className="slider-product-description text-center mt-5 mb-4">{product && product.description && product.description[0] && RichText.render(product.description)}</div>*/}
        {/*                          <AppButton className="see-product-details">{product && product.details_button_text ? product.details_button_text : "more"}</AppButton>*/}
        {/*                        </AppLink>*/}
        {/*                      </div>*/}
        {/*                    )}*/}
        {/*                  </div>*/}
        {/*                </div>*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </section>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="d-none d-sm-block category-slider">
          <section className="container-fluid p-0 h-100">
            <div className={"desktop-slider swiper-container " + `${category?._meta.uid + "v2"}`}>
              <div className="swiper-wrapper">
                {category.products.map(({ product }, index) =>
                  product !== null &&
                  <div key={index.toString()} className="swiper-slide">
                    <div className="slide-container flex-column text-center" style={{ backgroundImage: `url('${product?.background_image?.url}')` }}>
                      <div className="product-images-with-link">
                        <AppLink to={`/${category?._meta.uid}/${product?._meta.uid}`} pageContext={pageContext}>
                          <div className="category-image-container">
                            {product && !product.no_aspect_ratio_image && <img className="img-fluid" src={product?.product_image?.url}/>}
                            {product && product.no_aspect_ratio_image && <img className="img-fluid" src={product?.no_aspect_ratio_image?.url}/>}
                          </div>
                        </AppLink>
                      </div>
                      <div className="vertical-slide-product-name my-2">
                        {product && product.name}
                      </div>
                      <AppLink to={`/${category?._meta.uid}/${product?._meta.uid}`} className="product-more-button" pageContext={pageContext}>
                        {/*<div className="slider-product-name text-uppercase text-center">{product?.name}</div>*/}
                        <AppButton className="see-product-details">{product && product.details_button_text ? product.details_button_text : "more"}</AppButton>
                      </AppLink>
                    </div>
                  </div>
                )}
              </div>
              <div className={"swiper-button-prev" + " swiper-button-prev" + category?._meta.uid}/>
              <div className={"swiper-button-next" + " swiper-button-next" + category?._meta.uid}/>
            </div>
          </section>
        </div>
      </div>
      }
    </Fragment>
  )
})
